import { Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppButton = () => {
  const whatsappLink = `https://wa.me/971528918124`;

  return (
    <Button
      variant="contained"
      color="success"
      href={whatsappLink}
      target="_blank"
      sx={{
        position: "fixed",
        right: 20,
        bottom: 20,
        borderRadius: "50%",
        minWidth: "56px",
        height: "56px",
        boxShadow: 3,
        zIndex: 1000, 
      }}
    >
      <WhatsAppIcon sx={{ fontSize: "2rem" }} />
    </Button>
  );
};

export default WhatsAppButton;
